export enum ServiceEnum {
  SIM_ECOMMERCE = "SIM_ECOMMERCE",
  TRAVEL_SIM = "TRAVEL_SIM",
  NICE_SIM = "NICE_SIM",
  BUY_PACKAGE = "BUY_PACKAGE",
  AIR_TIME = "AIR_TIME",
  CASH_FLOW = "CASH_FLOW",
  ADD_BALANCE = "ADD_BALANCE",
  GOGO_SIM = "GOGO_SIM",
  IOT_SIM = "IOT_SIM"
}
